/**
 * Maps eCheck account type keys to their display labels.
 *
 * - CHECKING: 'Checking'
 * - CORPORATE: 'Corporate'
 * - CORP_SAVINGS: 'Corporate Savings'
 * - SAVINGS: 'Savings'
 */
export const accountTypeLabelMap = {
  CHECKING: 'Checking',
  CORPORATE: 'Corporate',
  CORP_SAVINGS: 'Corporate Savings',
  SAVINGS: 'Savings',
};
